import React from 'react';
import {
    BooleanField,
    Button,
    DateField,
    DeleteButton,
    EditButton,
    Link,
    ReferenceField,
    ReferenceManyField,
    RichTextField,
    Show,
    Tab,
    TabbedShowLayout,
    TextField,
} from 'react-admin';
import ExternalUrlField from '../inputs/ExternalUrlField';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import { Tree, NodeView, NodeActions } from 'ra-tree-ui-materialui';

const ThreadTitle = ({ record }) => {
    return <span>Thread { record ? `"${record.title}"` : '' }</span>
};

const PostsActions = props => (
    <NodeActions {...props}>
        <EditButton />
        <DeleteButton />
        <AddNewPostButton />
    </NodeActions>
);

const AddNewPostButton = ({ record }) => (
    <Button
        component={Link}
        label="Add a Reply"
        to={`/posts/create?parent=${record.id}&thread=${record.thread}&user=/users/${window.localStorage.getItem('ltk-comments-admin-id')}`}
        title="Add a Reply"
    >
        <ChatBubbleIcon />
    </Button>
);

export const ThreadShow = (props) => (
    <Show title={<ThreadTitle />} {...props}>
        <TabbedShowLayout>
            <Tab label="Thread">
                <TextField label="ID" source="id" />
                <ReferenceField label="User" source="user" reference="users">
                    <TextField source="username" />
                </ReferenceField>
                <BooleanField label="Closed?" source="closed" />
                <ExternalUrlField label="Link" source="link" />
                <TextField label="Title" source="title" />
                <DateField disabled label="Last Updated" source="updated_at" showTime sortBy="updatedAt" />
                <DateField disabled label="Created" source="created_at" showTime sortBy="createdAt" />
                <DateField disabled label="Deleted" source="deleted_at" showTime />
            </Tab>
            <Tab label="Message" path="message">
                <RichTextField label="Message" source="message" />
            </Tab>
            <Tab label="Posts" path="posts">
                <ReferenceManyField
                    filter={{ 'parent[exists]': 0 }}
                    sort={{ field: 'createdAt', order: 'DESC' }}
                    label="Replies"
                    reference="posts"
                    target="thread"
                    perPage={10000}
                    allowEmpty
                >
                    <Tree parentSource="parent">
                        <NodeView actions={<PostsActions />}>
                            <ReferenceField label="User" source="user" reference="users">
                                <TextField source="username" />
                            </ReferenceField>
                            <RichTextField source="message" />
                            <DateField disabled label="Created" source="created_at" showTime />
                        </NodeView>
                    </Tree>
                </ReferenceManyField>
            </Tab>
        </TabbedShowLayout>
    </Show>
);
